/* eslint-disable react/prop-types */
import React from "react";
import "../../assets/styles/App.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import { updateEyrisSettingsForSite } from "../../constants/endpoints";
import { putAuthenticatedData } from "../../utils/async";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { withTranslation } from "react-i18next";
import { T_GENERAL, T_SERVICE } from "../../constants/translations";

/**
 * This is the component for the Site Entitlement Settings modal in the Sites page. <br>
 * The site ID is passed as a prop called `siteID`
 *
 * @component
 */
class CustomEyrisModal extends React.Component {
  constructor(props) {
    super(props);

    this.t = props.t;
    this.i18n = props.i18n;

    this.state = {
      isLoaded: true,
      disableButton: false,
      eyrisUsername: this.props.eyrisSettings.eyrisUsername,
      eyrisPassword: this.props.eyrisSettings.eyrisPassword,
      eyrisAIEnabled: this.props.eyrisSettings.eyrisAIEnabled
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  componentDidMount() {}
  /**
   * Submits the form
   *
   *
   * @param {object} e      event listener
   */
  onSubmit() {
    var data = {
      eyrisAIEnabled: this.state.eyrisAIEnabled,
      eyrisUsername: this.state.eyrisUsername,
      eyrisPassword: this.state.eyrisPassword
    };
    this.setState({ isLoaded: false, disableButton: true });

    putAuthenticatedData(
      sessionStorage.getItem("domain") +
        updateEyrisSettingsForSite +
        "/" +
        this.props.siteId,
      data
    )
      .then(result => {
        this.setState({ isLoaded: true });
        if (result.status === 400) {
          this.setState({ isLoaded: true, disableButton: false });
        } else if (result.status === 200) {
          toast.success(
            this.t(T_SERVICE.toast.eyrisAISettingsUpdatedSuccessfully)
          );
          this.props.closePopup();
          this.props.resetList();
        }
        return result.json();
      })
      .then(resp => {
        if (
          resp.status.statusCode !== "OK" &&
          resp.status.statusCode !== "FORBIDDEN" &&
          resp.status.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp.status.message);
        }
      });
  }

  handleSubmit(event) {
    event.preventDefault();
  }
  render() {
    return (
      <div className="custommodal">
        <div className="custommodalinner entitlement-settings">
          <form className="loginpad" onSubmit={this.handleSubmit}>
            <h6 className="modal-heading">
              {this.t(T_SERVICE.viewSites.eyrisAISettings.header)}
            </h6>
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={this.props.closePopup}
              className="cancle"
            >
              {" "}
              x{" "}
            </Button>
            <hr className="hrpadding" />
            <div className="firstpage">
              <FormGroup controlId="email" bsSize="large">
                <div className="row formfont">
                  <div className="col-md-3 formfont enable-label">
                    {this.t(T_SERVICE.viewSites.eyrisAISettings.active)}
                  </div>
                  <div className="col-md-9">
                    <BootstrapSwitchButton
                      width={100}
                      height={10}
                      checked={this.state.eyrisAIEnabled}
                      onstyle="success"
                      onChange={checked => {
                        if (!checked) {
                          this.setState({
                            eyrisAIEnabled: checked,
                            eyrisUsername: "",
                            eyrisPassword: ""
                          });
                        }
                        this.setState({ eyrisAIEnabled: checked });
                      }}
                    />
                  </div>
                </div>
              </FormGroup>
              <FormGroup controlId="email" bsSize="large">
                <div className="row formfont">
                  <div className="col-md-3 formfont enable-label">
                    {this.t(T_SERVICE.viewSites.eyrisAISettings.username)}
                  </div>
                  <div className="col-md-9">
                    <FormControl
                      required
                      type="text"
                      name="eyrisUsername"
                      value={this.state.eyrisUsername}
                      onChange={this.onChange}
                      disabled={!this.state.eyrisAIEnabled}
                    />
                  </div>
                </div>
              </FormGroup>
              <FormGroup controlId="email" bsSize="large">
                <div className="row formfont">
                  <div className="col-md-3 formfont enable-label">
                    {this.t(T_SERVICE.viewSites.eyrisAISettings.password)}
                  </div>
                  <div className="col-md-9">
                    <FormControl
                      required
                      type="text"
                      name="eyrisPassword"
                      value={this.state.eyrisPassword}
                      onChange={this.onChange}
                      disabled={!this.state.eyrisAIEnabled}
                    />
                  </div>
                </div>
              </FormGroup>
              <Button
                onClick={this.onSubmit}
                className="loginbtn1 gateway-settings-btn submit-button"
                disabled={this.state.disableFirstButton}
              >
                {this.state.isLoaded ? (
                  this.t(T_GENERAL.submit)
                ) : (
                  <img
                    src={require("../../assets/images/button-loading.gif")}
                  />
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomEyrisModal);
